import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { readRegimeScheduleTotal, useRegimeScheduleTotal } from "./use-regime-schedule-total"

// A regime in the Maintenance Regimes list (table row or card) shows its Live total, or its Draft total
// when it has never gone live. It never falls back to Draft when a Live total is missing.
export function useListedRegimeScheduleTotal() {
    const { parentItem } = useBoundContext()
    return useRegimeScheduleTotal(parentItem, parentItem?.id, { state: listedState(parentItem) })
}

export function readListedRegimeScheduleTotal(item) {
    return readRegimeScheduleTotal(item, item?.id, listedState(item))
}

function listedState(item) {
    return item?.$?.hasLive ? "live" : undefined
}
